import { ROUTES } from "../../../api/api.routes";
import useCustomQuery from "../../../hooks/useQuery";
import { RemainingUsage } from "../../../types/db/schema/ai/usage.schema";

export const useUsage = () => {
  const { data, isLoading, mutate } = useCustomQuery<RemainingUsage>(ROUTES.Usage);

  return {
    usage: data,
    loadingUsage: isLoading,
    reloadUsage: mutate
  }
}